<script lang="ts">
    import HeroSmallTilesSide from "./HeroSmallTilesSide.svelte";
    import HeroLargeTilesUnder from "./HeroLargeTilesUnder.svelte";

    export let section: Section;
    export let index: number;
</script>

{#if section.type === 'small-tiles-side'}
    <HeroSmallTilesSide {section} {index} />
{:else if section.type === 'large-tiles-under'}
    <HeroLargeTilesUnder {section} {index} />
{/if}
